import { useEffect, useState } from "react";

/**
 * Hook to calculate magnetic bubble position
 * Applies magnetic edges on all devices
 */
export const useBubblePosition = (containerRef, bubbleRef, percentage) => {
  const [position, setPosition] = useState(0);

  useEffect(() => {
    const calculatePosition = () => {
      if (!containerRef.current || !bubbleRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const bubbleWidth = bubbleRef.current.offsetWidth;

      // Calculate the safe zone margins
      const safeMargin = bubbleWidth / 2;
      const minSafePosition = safeMargin / containerWidth;
      const maxSafePosition = 1 - safeMargin / containerWidth;

      // Always apply magnetic edges to keep the bubble fully visible
      const adjustedPosition = Math.min(
        Math.max(percentage, minSafePosition),
        maxSafePosition
      );

      setPosition(adjustedPosition);
    };

    calculatePosition();
    window.addEventListener("resize", calculatePosition);

    return () => window.removeEventListener("resize", calculatePosition);
  }, [containerRef, bubbleRef, percentage]);

  return position;
};
